import clsx from "clsx";

/** A labelled completion bar. Always paired with the count in text so colour is never the only signal. */
export function Progress({ value, max, label, className }: { value: number; max: number; label?: string; className?: string }) {
  const pct = max > 0 ? Math.round((value / max) * 100) : 0;
  return (
    <div className={clsx("flex flex-col gap-1", className)}>
      <div className="flex items-baseline justify-between gap-4 text-small text-ink-secondary">
        <span>{label ?? "Progress"}</span>
        <span>
          {value} of {max}
        </span>
      </div>
      <div role="progressbar" aria-valuemin={0} aria-valuemax={max} aria-valuenow={value} aria-label={label ?? "Progress"} className="h-2 w-full overflow-hidden rounded-sm bg-card-tinted">
        <div className="h-full bg-anchor" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
